import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Mixpanel } from '../../redux/Mixpanel';

import {
    Input
} from 'reactstrap';
import {
    fetchBillingDetails, showLoading, updateSmsAlertPreferences, fetchCurrency, fetchUser
} from '../../redux/actions';
import { colorTheme, UNIFORM_RESOURCE_LOCATORS } from '../../utils/constants';
import { IonButton, IonButtons, IonCol, IonContent, IonFab, IonFabButton, IonFabList, IonFooter, IonGrid, IonHeader, IonIcon, IonItem, IonLabel, IonMenuButton, IonModal, IonPage, IonRow, IonText, IonTitle, IonToolbar } from '@ionic/react';
import { Card } from '@tremor/react';
import { add, arrowBack, cashOutline, mail } from 'ionicons/icons';
import _ from 'lodash';
import StepwisePricing from '../StepwisePricing';

const HOMEPAGE = "homepage";
const PRICING_PLANS = "pricing_plans";

const mapsStateTopProps = state => {
    return {
        billing: state.billing,
        user: state.user,
        currency: state.currency
    }
}

const mapDispatchToProps = {
    fetchBillingDetails,
    showLoading,
    updateSmsAlertPreferences,
    fetchCurrency,
    fetchUser
}

const MONTH = ["January","February","March","April",
    "May","June","July","August","September",
    "October","November","December"];

class Billing extends React.Component{
    constructor(props){
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleBackButton = this.handleBackButton.bind(this);
        this.state = {
            tab: HOMEPAGE,
            lowSmsBalanceReminder: false,
            smsReminderThreshold: 0,
            changesMade: false,
            subscriptionExpired: false,
            paymentType: "subscription"
        };
    }

    async fetchInitialData() {
        await Promise.all([
            (
                async () => {
                    if (_.isEmpty(this.props.billing)) {
                        this.props.showLoading(true);
                        await this.props.fetchBillingDetails();
                    }
                }
            )(),
            (
                async () => {
                    if (_.isEmpty(this.props.user)) {
                        this.props.showLoading(true);
                        await this.props.fetchUser();
                    }
                }
            )(),
            //fetch Currency when we allow other payment options other than mpesa
            // (
            //     async () => {
            //         if (_.isEmpty(this.props.currency)) {
            //             this.props.showLoading(true);
            //             await this.props.fetchCurrency();
            //         }
            //     }
            // )()
        ]);
    }

    async componentDidMount(){
        this.props.showLoading(true);
        await this.fetchInitialData();
        let lowSmsBalanceReminder = this.props.billing && this.props.billing.customerAccount ? this.props.billing.customerAccount.lowSmsBalanceReminder : false
        let smsReminderThreshold = this.props.billing && this.props.billing.customerAccount ? this.props.billing.customerAccount.smsReminderThreshold : 0
        this.setState({lowSmsBalanceReminder: lowSmsBalanceReminder, smsReminderThreshold: smsReminderThreshold});
    }

    async componentDidUpdate(prevProps){
        if (prevProps.location !== this.props.location){
            this.setState({tab: HOMEPAGE});
        }
    }

    handleChange(event) {
        const target = event.target;
        let name = target.name;
        let val = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({changesMade: true, [name]: val});
    }

    renderBilling(){
        let subName = "";
        let numUnits = "";
        let subCost = "";
        let paymentSchedule = "";
        let subscriptionBalance = "";

        let nextBillingDate = "";
        let trialEndDate = "";
        let account = null;
        let constants = null;
        let customerSuportNumber = "";
        let customerSuportEmail = "";

        if (this.props.billing && this.props.billing.customerAccount){
            account = this.props.billing.customerAccount;
            constants = this.props.billing.constants;
            subName = account.accountPlan;
            subCost = account.subscriptionCost;
            subscriptionBalance = account.subscriptionBalance? account.subscriptionBalance.toString() : "0";
            paymentSchedule = account.paymentSchedule;
            numUnits = account.numUnits;
            nextBillingDate = account.nextBillingDate? new Date(account.nextBillingDate) : "";
            const now = new Date();
            customerSuportNumber = constants.customer_support_number;
            customerSuportEmail = constants.customer_support_email;
            trialEndDate = account.trialEndDate? new Date(account.trialEndDate) : "";
            // if trial end date has already passed then we shouldn't show it because it is now irrelevant.
            trialEndDate = (trialEndDate && trialEndDate > now)? trialEndDate : "";
        }

        const formatSchedule = (schedule) => {
            if (!schedule) {
                return "";
            }
            const normalized = schedule.toString().toLowerCase();
            return normalized.charAt(0).toUpperCase() + normalized.slice(1);
        };

        return (
            <IonCol size="12" className="mb-1">
                <IonRow className="m-1 mt-2">
                    <IonCol size="12">
                        <p style={{fontWeight: "bold", fontSize: "1.2em"}}>Subscription</p>
                        <hr /> <br />
                    </IonCol>
                </IonRow>
                <IonRow className="m-1">
                    <IonCol size="12">
                    <IonGrid>
                        <IonRow>
                            <IonCol className='billing-columns'><b>Account Plan</b></IonCol>
                            <IonCol className='billing-columns'>{account ? <IonText>{subName}</IonText> : null}</IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol className='billing-columns'><b>Number of Units</b></IonCol>
                            <IonCol className='billing-columns'>{account ? <IonText>{numUnits}</IonText> : null}</IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol className='billing-columns'><b>Subscription cost</b></IonCol>
                            <IonCol className='billing-columns'>{account ? <IonText>{subCost}</IonText> : null}</IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol className='billing-columns'><b>Billing schedule</b></IonCol>
                            <IonCol className='billing-columns'>{account ? <IonText>{formatSchedule(paymentSchedule)}</IonText> : null}</IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol className='billing-columns'><b>Amount due</b></IonCol>
                            <IonCol className='billing-columns'>{account ? <IonText>{subscriptionBalance} Kshs</IonText> : null}</IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol className='billing-columns'><b>Due Date</b></IonCol>
                            <IonCol className='billing-columns'>{account ? <IonText>{MONTH[nextBillingDate.getMonth()]} {nextBillingDate.getDate()}, {nextBillingDate.getFullYear()}</IonText> : null}</IonCol>
                        </IonRow>
                        {trialEndDate &&
                            <IonRow>
                                <IonCol className="text-danger billing-columns"><b>Trial End Date</b></IonCol>
                                <IonCol className="text-danger billing-columns">{account ? <IonText>{MONTH[trialEndDate.getMonth()]} {trialEndDate.getDate()}, {trialEndDate.getFullYear()}</IonText> : null}</IonCol>
                            </IonRow>
                        }
                    </IonGrid>
                    </IonCol>
                </IonRow>
                <IonRow className="m-2">
                    <p>
                        Your current plan is the <b>{subName} plan </b>
                        because you have <b>{numUnits} units</b>. If you believe this is a mistake,
                        please call customer support {customerSuportNumber} or email {customerSuportEmail}.
                    </p>
                </IonRow>
            </IonCol>
        );
    }

    handleSaveChanges(){
        if (this.state.changesMade){
            this.props.showLoading(true);
            this.props.updateSmsAlertPreferences({
                lowSmsBalanceReminder: this.state.lowSmsBalanceReminder,
                smsReminderThreshold: this.state.smsReminderThreshold
            })
        }

        Mixpanel.track("BillingSettings tab: save changes btn");
    }

    renderAlertMeSection(){
        return (
            <IonCol size="12">
                <p><b>Alert me:</b></p>
                <IonItem lines='none'>
                    <Input
                        slot="start"
                        type='checkbox'
                        id="lowSmsBalanceReminder"
                        name="lowSmsBalanceReminder"
                        checked={this.state.lowSmsBalanceReminder}
                        value={this.state.lowSmsBalanceReminder}
                        onChange={this.handleChange}
                        data-testid="low-balance-alerts"
                    />
                    <IonLabel className='ml-2 ion-text-wrap'>When my SMS balance is below:</IonLabel>
                </IonItem>
                <IonItem lines='none'>
                    <Input
                        id="smsReminderThreshold"
                        name="smsReminderThreshold"
                        type="number"
                        value={this.state.smsReminderThreshold}
                        onChange={this.handleChange}
                    />
                </IonItem>
                <IonButton
                    style={{ borderColor: colorTheme["primary"]["700"] }}
                    className="my-3"
                    onClick={this.handleSaveChanges.bind(this)}
                    data-testid="save-changes-btn"
                >
                    Save Changes
                </IonButton>
            </IonCol>
        );
    }

    renderSMSBalance(){
        let account = null;
        let constants = null;
        let smsBalance = "";
        let costPerSMS = "";
        if (this.props.billing && this.props.billing.customerAccount){
            account = this.props.billing.customerAccount;
            constants = this.props.billing.constants;
            smsBalance = account.smsBalance? account.smsBalance.toString() : "0";
            costPerSMS = constants.cost_per_sms;
        }
        return (
            <IonCol>
                <IonRow className="m-1 mt-2">
                    <IonCol size="12">
                        <p style={{fontWeight: "bold", fontSize: "1.2em"}}>Sms Balance</p>
                        <hr /> <br />
                    </IonCol>
                </IonRow>

                <IonRow className="m-1">
                    <IonGrid>
                        <IonRow>
                            <IonCol className='billing-columns'><b>SMS Balance</b></IonCol>
                            <IonCol className='billing-columns'>{smsBalance !== "" ? <IonText>{smsBalance} Kshs</IonText> : null}</IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol className='billing-columns'><b>Cost per SMS</b></IonCol>
                            <IonCol className='billing-columns'>{costPerSMS !== "" ? <IonText>{costPerSMS} Kshs</IonText> : null}</IonCol>
                        </IonRow>
                    </IonGrid>
                </IonRow>

                <IonRow className='m-1'>
                {this.props.user && this.props.user.teamMember && this.props.user.teamMember.isAdmin && this.renderAlertMeSection()}
                </IonRow>
            </IonCol>
            );

    }

    onClickPricingPlansSubscription(){
        this.setState({tab: PRICING_PLANS, paymentType: "subscription"});
        Mixpanel.track("BillingSettings tab: pricing plans btn");
    }

    onClickPricingPlansSms(){
        this.setState({tab: PRICING_PLANS, paymentType: "sms"});
        Mixpanel.track("BillingSettings tab: pricing plans btn");
    }

    handleBackButton(){
        if (this.state.subscriptionExpired) {
            this.props.history.push(UNIFORM_RESOURCE_LOCATORS.subscriptionExpired);
        } else if (this.state.tab !== HOMEPAGE) {
            this.setState({ tab: HOMEPAGE });
        }
    }

    renderBackButton(){
        return(
            <IonRow className="d-flex justify-content-start">
                <IonButton className="mx-2"
                    style={{ borderColor: colorTheme["primary"]["700"] }}
                    data-testid="billingBackBtn"
                    onClick={this.handleBackButton.bind(this)}
                    >
                    <IonIcon slot="start" icon={arrowBack} />
                        Back
                </IonButton>
            </IonRow>
        )
    }

    renderHomePage(){
        return (
            <Card className='p-1'>
                <IonCol>
                    <IonRow>
                        {this.renderBilling()}
                    </IonRow>

                    <IonRow>
                        {this.renderSMSBalance()}
                    </IonRow>

                </IonCol>
            </Card>);
    }

    renderPricingPlans(){
        return (
        <IonModal isOpen={this.state.tab === PRICING_PLANS} onDidDismiss={this.handleBackButton}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Pricing Plans</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={this.handleBackButton}>Close</IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <StepwisePricing
                    paymentType={this.state.paymentType}
                />
            </IonContent>
        </IonModal>
        );
    }

    render(){
        return (
            <IonPage>
                <IonHeader>
                    <IonToolbar>
                        <IonButtons slot="start">
                            <IonMenuButton />
                        </IonButtons>
                        <IonTitle>Billing</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    {this.state.tab == HOMEPAGE && this.renderHomePage()}

                    {this.state.tab == PRICING_PLANS && this.renderPricingPlans()}

                    <IonFab className='ion-fab' slot="fixed" vertical="bottom" horizontal="end">
                        <IonFabButton aria-label="Actions">
                            <IonIcon icon={add} />
                        </IonFabButton>
                        <IonFabList side="top">
                            <IonFabButton
                                onClick={this.onClickPricingPlansSubscription.bind(this)}
                                data-testid="account-top-up-btn"
                                data-desc="Pay Subscription"
                            >
                                <IonIcon icon={cashOutline} />
                            </IonFabButton>
                            <IonFabButton
                                onClick={this.onClickPricingPlansSms.bind(this)}
                                data-testid="sms-balance-btn"
                                data-desc="Buy SMS"
                            >
                                <IonIcon icon={mail} />
                            </IonFabButton>
                        </IonFabList>
                    </IonFab>

                </IonContent>
            </IonPage>);
    }
}

export default withRouter(connect(
    mapsStateTopProps,
    mapDispatchToProps
)(Billing));